export default "__VITE_ASSET__DLviZq7M__"